// prefer default export if available
const preferDefault = m => m && m.default || m;
exports.components = {
  "component---gatsby-theme-mdx-deck-src-templates-deck-js": () => import("./../../../../gatsby-theme-mdx-deck/src/templates/deck.js" /* webpackChunkName: "component---gatsby-theme-mdx-deck-src-templates-deck-js" */)
};